module.exports = __webpack_public_path__ + "img/Done-rafiki.32d0dea1.png";